import { call, put, takeLatest } from 'redux-saga/effects';
import { networthGrowthActions as actions } from '.';
import { authenticatedGet } from 'remote/api';
import { PayloadAction } from '@reduxjs/toolkit';
// function* doSomething() {}

export function* networthGrowthSaga(action: PayloadAction<any>) {
  try {
    const { to, from } = action.payload;
    const response = yield call(
      authenticatedGet,
      `${process.env.REACT_APP_API_URL}/networth/growth?from=${from}&to=${to}`,
    );
    yield put(actions.networthGrowthSuccess(response.data));
  } catch (error: any) {
    yield put(actions.networthGrowthFail(error.response.data));
  }
}

export function* watchnetworthGrowthSaga() {
  yield takeLatest(actions.networthGrowth.type, networthGrowthSaga);
}
